export function dispatchCustomEvent(type, detail) {
    if (typeof window !== 'undefined' &&
        typeof window.dispatchEvent === 'function') {
        window.dispatchEvent(new CustomEvent(type, { detail }));
    }
}
